import React, { SVGProps, FC } from 'react';

export const Quote: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={36}
    height={24}
    viewBox="0 0 36 24"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M23.514 11.798c-.323-7.11 5.414-10.1 11.96-10.504V0c-9.212-.08-16.727 5.171-16.727 14.545 0 5.575 3.474 9.454 8.565 9.454 4.283 0 7.596-2.99 7.596-7.273 0-4.04-2.91-6.706-6.546-6.706-2.262 0-3.959.727-4.848 1.777Zm-18.747 0c-.323-7.11 5.414-10.1 11.96-10.504V0C7.515-.08 0 5.172 0 14.546 0 20.12 3.475 24 8.565 24c4.283 0 7.596-2.99 7.596-7.273 0-4.04-2.909-6.706-6.545-6.706-2.263 0-3.96.727-4.849 1.777Z" />
  </svg>
);
